// extracted by css-extract-rspack-plugin
export default {"reportLayout":"kJ5XfEQ4PYQTBCSw__reportLayout___","section":"GJxy8ikLN_UNcl5Z__section___"};